import type { UiAlign, UiPosition } from '$lib/types';

export const POP_OUT_SIDE: Record<UiPosition, 'top' | 'right' | 'bottom' | 'left'> = {
	Top: 'top',
	Right: 'right',
	Bottom: 'bottom',
	Left: 'left'
};

export const POP_OUT_ALIGN: Record<UiAlign, 'start' | 'center' | 'end'> = {
	Start: 'start',
	Center: 'center',
	End: 'end'
};

export const POP_OUT_DEFAULT_OFFSET = 10;

export const TOOLTIP_DEFAULT_DELAY_MS = 200;

export const MODAL_WIDE_CLASS = 'modal-wide';
